// extracted by mini-css-extract-plugin
module.exports = {"item":"parcelInfo_item__1CMjO","label":"parcelInfo_label__2VNg6"};